<template>
  <div class="col-md-12 pl-0 pr-0">
    <!-- <div class="col-md-12 yuanjiao pt-3 pb-3 pl-0 pr-0 sjbzt"
			style="font-size: calc(7px + 0.4vw);line-height: calc(15px + 0.5vw);">
			<div class="col-md-12 d-flex pl-0 pr-0">
				<div @click="fun(1)" class="pt-3 pb-3 curpo qieh sjbzt"
					:style="{'background':show==1?'#FFFFFF':'#FFFAF0','font-weight':show==1?'700':'500','color':show==1?'':'#999999'}">
					{{$t('活动中数据')}}</div>
				<div @click="fun(2)" class="pt-3 pb-3 curpo qieh sjbzt"
					:style="{'background':show==2?'#FFFFFF':'#FFFAF0','font-weight':show==2?'700':'500','color':show==2?'':'#999999'}">
					{{$t('活动后数据')}}</div>
			</div>
			<hdzsj ref="hdzsj" v-if="show==1"></hdzsj>
			<hdhsj ref="hdhsj" v-if="show==2"></hdhsj>
		</div> -->
    <div class="yuanjiao baise p-3 mt-3 mb-3">
      <div class="mb-3">
        <img @click="fanhui(0)" class="mt-1 mb-2 curpo dcbd" style="width: calc(25px + 0.4vw);" src="@/img/login/icon_fanhui@2x.png" alt="" />
      </div>
      <div class="sjbzt mb-2" style="font-weight: 600;font-size: calc(10px + 0.4vw);">{{ $t("摘要") }}</div>
      <div class="sjbxzt" style="font-size: calc(7px + 0.4vw);line-height: calc(20px + 0.5vw);">
        <div class="pl-0 pr-0" >{{ infos.summary }}</div>
      </div>
      <div class="sjbzt mb-3 mt-3" style="font-weight: 600;font-size: calc(10px + 0.4vw);">{{ $t("計畫基本資訊") }}</div>
      <div class="d-flex justify-content-stretch sjbxzt" style="font-size: calc(9px + 0.4vw);gap: 1rem;">
        <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: 33%;">
          <div class="mb-2" style="color: #666666;">{{ $t("計畫名稱") }}</div>
          <div>{{ infos.name }}</div>
        </div>
        <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: 33%;">
          <div class="mb-2" style="color: #666666;">{{ $t("主辦單位") }}</div>
          <div>{{ infos.organization.name }}</div>
        </div>
        <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: 33%;">
          <div class="mb-2" style="color: #666666;">{{ $t("協辦單位") }}</div>
          <div v-for="(item,index) in infos.co_organizer" :key="index">{{ item.name }}</div>
        </div>
      </div>
      <div class="d-flex justify-content-stretch sjbxzt mt-3" style="font-size: calc(9px + 0.4vw);gap: 1rem;">
        <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: 33%;">
          <div class="mb-2" style="color: #666666;">{{ $t("計劃種類") }}</div>
          <div>{{ infos.category_name }}</div>
        </div>
        <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: 33%;">
          <div class="mb-2" style="color: #666666;">{{ $t("計畫地點") }}</div>
          <div>{{ infos.address }}</div>
        </div>
        <div class="pl-3 pr-3 pt-2 pb-2 yuanjiao" style="background: #F6F4F0;width: 33%;">
          <div class="mb-2" style="color: #666666;">{{ $t("計畫時間") }}</div>
          <div>{{ infos.start_date + '-' + infos.end_date }}</div>
        </div>
      </div>
      <div class="sjbzt mb-3 mt-4" style="font-weight: 600;font-size: calc(10px + 0.4vw);">{{ $t("計畫目标") }}</div>
      <div class="mb-3 sjbzt mt-3" v-if="infos.stakeholder.length>0" style="font-weight: 600;font-size: calc(12px + 0.4vw);">{{ $t("重要利害關係人") }}</div>
      <div class="d-flex none" v-if="infos.stakeholder.length>0" style="flex-wrap: wrap;justify-content: space-between;">
        <div class="mr-2 p-3 sjbxzt mb-2" v-for="(item,index) in infos.stakeholder" :key="index" style="width: 24%;font-size: calc(9px + 0.4vw);background: #FFFAF0;border-left: 3px solid #ffd672;">
          {{ item.name + item.num + item.unit }}
        </div>
      </div>
      <div class="show">
        <div class="d-flex" v-if="infos.stakeholder.length>0" style="flex-wrap: wrap;justify-content: space-between;">
          <div class="mr-2 p-3 sjbxzt" v-for="(item,index) in infos.stakeholder" :key="index" style="width: 49%;font-size: calc(9px + 0.4vw);background: #FFFAF0;border-left: 3px solid #ffd672;">
            {{ item.name + item.num + item.unit }}
          </div>
        </div>
      </div>
      <!-- <div v-for="(items,indexs) in input" :key="indexs">
        <div class="sjbzt mt-4" style="font-weight: 600;font-size: calc(10px + 0.4vw);">{{ $t("第") + items.year + $t("年度資源投入分析") }}</div>
        <div class="mt-3 mb-4" v-if="items.value.human.length>0">
          <div class="d-flex justify-content-between align-items-center mt-3 mb-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">
            <div>{{ $t("人力投入") }}</div>
            <div style="color: #666666;">{{ $t("參與志工") }}</div>
          </div>
          <div class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" style="background: #FFFAF0;font-size: calc(9px + 0.4vw);">
            <div style="width: 25%;">{{ $t("志工人數") }}</div>
            <div style="width: 25%;">{{ $t("總服務時數") }}</div>
            <div style="width: 25%;">{{ $t("總積分") }}</div>
            <div style="width: 25%;">{{ $t("時薪") }}</div>
          </div>
          <div v-for="(item,index) in items.value.human" :key="index" class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" :style="{'background':index % 2 == 0 ? '#FDFDFC' : '#F6F4F0'}" style="font-size: calc(9px + 0.4vw);">
            <div style="width: 25%;">{{ item.num }}</div>
            <div style="width: 25%;">{{ item.hour }}</div>
            <div style="width: 25%;">{{ (item.price * item.hour).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
            <div style="width: 25%;">{{ item.price }}</div>
          </div>
          <div class="mt-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ $t("總好人積分：") }}{{ (totalgroup(indexs)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
        </div>
        <div class="mb-4" v-if="items.value.material.length>0">
          <div class="d-flex justify-content-between align-items-center mt-3 mb-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">
            <div>{{ $t("物力投入") }}</div>
            <div style="color: #666666;">{{ $t("捐贈物資") }}</div>
          </div>
          <div class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" style="background: #FFFAF0;font-size: calc(9px + 0.4vw);">
            <div style="width: 20%;">{{ $t("名稱") }}</div>
            <div style="width: 20%;">{{ $t("計量單位") }}</div>
            <div style="width: 20%;">{{ $t("收到數量") }}</div>
            <div style="width: 20%;">{{ $t("總金額") }}</div>
            <div style="width: 20%;">{{ $t("企業或團體") }}</div>
          </div>
          <div v-for="(item,index) in items.value.material" :key="index" class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" :style="{'background':index % 2 == 0 ? '#FDFDFC' : '#F6F4F0'}" style="font-size: calc(9px + 0.4vw);">
            <div style="width: 20%;">{{ item.name }}</div>
            <div style="width: 20%;">{{ item.unit }}</div>
            <div style="width: 20%;">{{ item.num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
            <div style="width: 20%;">{{ (item.amount + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
            <div style="width: 20%;">{{ item.enterprise }}</div>
          </div>
          <div class="mt-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ $t("捐贈物資總額：") }}{{ (totalsupplies(indexs) + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
        </div>
        <div class="mb-4 sjbxzt" style="font-size: calc(9px + 0.4vw);">
          <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
            <div>{{ $t("金錢投入") }}</div>
          </div>
          <div class="pt-3 pb-3 yuanjiao text-center" style="background: #FFFAF0;">
            <div class="mb-2">{{ $t("第") + items.year + $t("年度預算") }}</div>
            <div>{{ (items.value.budget + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          </div>
        </div>
        <div class="mb-4 sjbxzt" style="font-size: calc(9px + 0.4vw);">
          <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
            <div>{{ $t("組織金錢投入") }}</div>
            <div style="color: #666666;">{{ $t("收入項") }}</div>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-3 text-center">
            <div class="yuanjiao pt-3 pb-3" style="background: #FFFAF0;width: 49%;">{{ $t("內部資金") }} {{ (items.value.internal_funds + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
            <div class="yuanjiao pt-3 pb-3" style="background: #FFFAF0;width: 49%;">{{ $t("專案補助") }} {{ (items.value.project_assistance + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          </div>
          <div class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" style="background: #FFFAF0;font-size: calc(9px + 0.4vw);">
            <div style="width: 25%;">{{ $t("捐款記錄") }}</div>
            <div style="width: 25%;">{{ $t("個人捐款") }}</div>
            <div style="width: 25%;">{{ $t("企業捐款") }}</div>
            <div style="width: 25%;">{{ $t("總額") }}</div>
          </div>
          <div v-for="(item,index) in items.value.donation" :key="index" class="d-flex align-items-center pt-2 pb-2 text-center sjbxzt" :style="{'background':index % 2 == 0 ? '#FDFDFC' : '#F6F4F0'}" style="font-size: calc(9px + 0.4vw);">
            <div style="width: 25%;">{{ item.info.name }}</div>
            <div style="width: 25%;">{{ item.info.personal_amount }}</div>
            <div style="width: 25%;">{{ item.info.enterprise_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
            <div style="width: 25%;">{{ (item.info.received_amount + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          </div>
          <div class="mt-2 sjbxzt" style="font-size: calc(9px + 0.4vw);">{{ $t("捐款總額：") }}{{ (items.value.internal_funds + items.value.project_assistance + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
        </div>
        <div class="mb-4 sjbxzt" style="font-size: calc(9px + 0.4vw);">
          <div class="pt-3 pb-3 yuanjiao text-center" style="background: #FFFAF0;">
            <div>{{ $t("組織投入金錢總額") }} {{ (totalorganize(indexs) + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          </div>
        </div>
        <div class="d-flex align-items-center none">
          <div :id="'chartcontainers' + indexs" style="height: 400px;width: calc(26rem + 0.4vw);"></div>
          <div style="width: 30%;">
            <div style="font-size: calc(9px + 0.4vw);font-weight: 500;">{{ $t("經費使用說明")}}</div>
            <div>
              <span>{{ items.value.illustrate }}</span>
            </div>
          </div>
        </div>
        <div class="show mb-3">
          <div :id="'chartcontainer' + indexs" style="height: 300px;width: calc(20rem + 0.4vw);"></div>
          <div style="width: 100%;">
            <div class="sjbzt" style="font-size: calc(9px + 0.4vw);">{{ $t("經費使用說明")}}</div>
            <div>
              <span class="sjbxzt">{{ items.value.illustrate }}</span>
            </div>
          </div>
        </div>
        <div class="mb-4 sjbxzt" style="font-size: calc(9px + 0.4vw);">
          <div class="pt-3 pb-3 yuanjiao text-center" style="background: #FCD7D5;">
            <div>{{ $t("費用支出總額") }} {{ ((totalorganize(indexs) + numg(indexs) + numq(indexs) + numw(indexs)) + ' NT$').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</div>
          </div>
        </div>
      </div>
      <div>
        <div v-for="(items,indexs) in out_put" :key="indexs">
          <div class="sjbxzt" style="font-size: calc(9px + 0.4vw);">
            <div class="d-flex justify-content-between align-items-center mb-3 mt-4">
              <div class="sjbzt" style="font-size: calc(10px + 0.4vw);font-weight: 600;">{{$t("第") + items.year + $t("年量化產出") }}</div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>{{ $t("好事道平臺產出") }}</div>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="yuanjiao p-3 d-flex align-items-center justify-content-between" style="background: #F6F4F0;width: 49%;">
                <div>{{ $t("參與人數") }}</div>
                <div>{{ items.value.member_num }}</div>
              </div>
              <div class="yuanjiao p-3 d-flex align-items-center justify-content-between" style="background: #F6F4F0;width: 49%;">
                <div>{{ $t("志工人數") }}</div>
                <div>{{ items.value.volunteer_num }}</div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="yuanjiao p-3 d-flex align-items-center justify-content-between sjbxzt" style="background: #F6F4F0;width: 49%;font-size: calc(9px + 0.4vw);">
                <div class="d-flex align-items-center">
                  <div class="mr-2"><img style="width: calc(20px + 0.4vw);" src="@/img/daohangl/pic_hssy_haorenbi@2x.png" alt=""></div>
                  <div>{{ $t("發行好人積分") }}</div>
                </div>
                <div>{{ items.value.good_coin }}</div>
              </div>
              <div class="yuanjiao p-3 d-flex align-items-center justify-content-between sjbxzt" style="background: #F6F4F0;width: 49%;font-size: calc(9px + 0.4vw);">
                <div class="d-flex align-items-center">
                  <div class="mr-2"><img style="width: calc(20px + 0.4vw);" src="@/img/daohangl/pic_hssy_tanbi@2x.png" alt=""></div>
                  <div>{{ $t("發行碳積分") }}</div>
                </div>
                <div>{{ items.value.carbon_coin }}</div>
              </div>
            </div>
            <div v-if="items.value.quantitative_environmental>0 || items.value.quantitative_social>0 || items.value.quantitative_economic>0" class="d-flex justify-content-between align-items-center mb-3 mt-3">
              <div>{{ $t("企業/團體產出") }}</div>
            </div>
            <div v-if="items.value.quantitative_environmental>0 || items.value.quantitative_social>0 || items.value.quantitative_economic>0" class="d-flex align-items-center justify-content-stretch none" style="gap: 1rem;">
              <div class="yuanjiao p-3" style="width: 32.5%;background: #F6F4F0;">
                <div class="mb-2">{{ $t("環境效益") }}</div>
                <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in items.value.quantitative_environmental" :key="index" style="background: #EAE6DE;">
                  <div>{{ item.results }}</div>
                  <div>{{ item.description }}</div>
                </div>
              </div>
              <div class="yuanjiao p-3" style="width: 32.5%;background: #F6F4F0;">
                <div class="mb-2">{{ $t("社會效益") }}</div>
                <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in items.value.quantitative_social" :key="index" style="background: #EAE6DE;">
                  <div>{{ item.results }}</div>
                  <div>{{ item.description }}</div>
                </div>
              </div>
              <div class="yuanjiao p-3" style="width: 32.5%;background: #F6F4F0;">
                <div class="mb-2">{{ $t("經濟效益") }}</div>
                <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in items.value.quantitative_economic" :key="index" style="background: #EAE6DE;">
                  <div>{{ item.results }}</div>
                  <div>{{ item.description }}</div>
                </div>
              </div>
            </div>
            <div v-if="items.value.quantitative_environmental>0 || items.value.quantitative_social>0 || items.value.quantitative_economic>0" class="show">
              <div class="yuanjiao p-3 mb-3" style="background: #F6F4F0;">
                <div class="mb-2">{{ $t("環境效益") }}</div>
                <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in items.value.quantitative_environmental" :key="index" style="background: #EAE6DE;">
                  <div>{{ item.results }}</div>
                  <div>{{ item.description }}</div>
                </div>
              </div>
              <div class="yuanjiao p-3 mb-3" style="background: #F6F4F0;">
                <div class="mb-2">{{ $t("社會效益") }}</div>
                <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in items.value.quantitative_social" :key="index" style="background: #EAE6DE;">
                  <div>{{ item.results }}</div>
                  <div>{{ item.description }}</div>
                </div>
              </div>
              <div class="yuanjiao p-3" style="background: #F6F4F0;">
                <div class="mb-2">{{ $t("經濟效益") }}</div>
                <div class="yuanjiao pl-3 pr-3 pt-2 pb-2 d-flex align-items-center justify-content-between" v-for="(item,index) in items.value.quantitative_economic" :key="index" style="background: #EAE6DE;">
                  <div>{{ item.results }}</div>
                  <div>{{ item.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { impact_data_new } from "@/request/hshd/index.js";
import * as echarts from "echarts";
// import hdzsj from "./hdsj/hdzsj.vue";
// import hdhsj from "./hdsj/hdhsj.vue";
export default {
  // components: {
  // 	hdzsj,
  // 	hdhsj,
  // },
  data() {
    return {
      show: 1,
      isLoading: false,
      name: "",
      input: [],
      out_put: [],
      infos: {},
    };
  },
  created() {},
  mounted() {
    this.info();
  },
  computed: {},
  methods: {
    fanhui(e) {
      this.$router.go(-1);
    },
    totalorganize(e) {
      let a = "";
      for (
        let index = 0;
        index < this.input[e].value.donation.length;
        index++
      ) {
        a = a + this.input[e].value.donation[index].info.received_amount;
      }
      return Number(a);
    },
    totalsupplies(e) {
      let a = "";
      for (
        let index = 0;
        index < this.input[e].value.material.length;
        index++
      ) {
        a = a + this.input[e].value.material[index].amount;
      }
      return a;
    },
    totalgroup(e) {
      let a = "";
      for (let index = 0; index < this.input[e].value.human.length; index++) {
        a =
          a +
          this.input[e].value.human[index].price *
            this.input[e].value.human[index].hour;
      }
      return a;
    },
    async info() {
      const { data, code } = await impact_data_new({
        id: this.$route.params.id,
      });
      if (code == 200) {
        this.infos = data.data.info;
        this.input = data.data.input;
        this.out_put = data.data.output;
        // for (let index = 0; index < this.input.length; index++) {
        //   setTimeout(() => {
        //     this.getBar(
        //       this.totalorganize(index),
        //       this.numg(index),
        //       this.numq(index),
        //       this.numw(index),
        //       index
        //     );
        //     this.getBars(
        //       this.totalorganize(index),
        //       this.numg(index),
        //       this.numq(index),
        //       this.numw(index),
        //       index
        //     );
        //   }, 10);
        // }
      }
    },
    getBar(a, b, c, d, e) {
      console.log(
        a,
        b,
        c,
        d,
        document.getElementById("chartcontainers" + e),
        "chartcontainers" + e
      );
      var chartDom = document.getElementById("chartcontainers" + e);
      let myChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: this.$t("成果統計"),
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 25,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            center: ["50%", "60%"],
            data: [
              {
                value: a,
                name:
                  "行政費用：" +
                  (a > 0 ? (a / (a + b + c + d)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#ffd672",
                },
              },
              {
                value: b,
                name:
                  "設備費用：" +
                  (b > 0 ? (b / (a + b + c + d)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#fab1ab",
                },
              },
              {
                value: c,
                name:
                  "營運費用：" +
                  (c > 0 ? (c / (a + b + c + d)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#fdbc94",
                },
              },
              {
                value: d,
                name:
                  "其他費用：" +
                  (d > 0 ? (d / (a + b + c + d)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#a6d1ff",
                },
              },
            ],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    getBars(a, b, c, d, e) {
      console.log(
        a,
        b,
        c,
        d,
        document.getElementById("chartcontainer" + e),
        "321"
      );
      var chartDom = document.getElementById("chartcontainer" + e);
      let myChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: this.$t("成果統計"),
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 25,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            center: ["50%", "60%"],
            data: [
              {
                value: a,
                name:
                  "行政費用：" +
                  (a > 0 ? (a / (a + b + c + d)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#ffd672",
                },
              },
              {
                value: b,
                name:
                  "設備費用：" +
                  (b > 0 ? (b / (a + b + c + d)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#fab1ab",
                },
              },
              {
                value: c,
                name:
                  "營運費用：" +
                  (c > 0 ? (c / (a + b + c + d)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#fdbc94",
                },
              },
              {
                value: d,
                name:
                  "其他費用：" +
                  (d > 0 ? (d / (a + b + c + d)) * 100 : 0).toFixed(2) +
                  "%",
                itemStyle: {
                  color: "#a6d1ff",
                },
              },
            ],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    numg(e) {
      let a = "";
      for (
        let index = 0;
        index < this.input[e].value.equipment_expense.length;
        index++
      ) {
        a = a + this.input[e].value.equipment_expense[index].amount;
      }
      return Number(a);
    },
    numq(e) {
      let a = "";
      for (
        let index = 0;
        index < this.input[e].value.operating_expense.length;
        index++
      ) {
        a = a + this.input[e].value.operating_expense[index].amount;
      }
      return Number(a);
    },
    numw(e) {
      let a = "";
      for (
        let index = 0;
        index < this.input[e].value.other_expense.length;
        index++
      ) {
        a = a + this.input[e].value.other_expense[index].amount;
      }
      return Number(a);
    },
    // fun(e) {
    // 	this.show = e;
    // 	if (e == 1) {
    // 		setTimeout(() => {
    // 			this.$refs.hdzsj.msg(this.id, this.name);
    // 		}, 40);
    // 	} else {
    // 		setTimeout(() => {
    // 			this.$refs.hdhsj.msg(this.id, this.name);
    // 		}, 40);
    // 	}
    // },
  },
};
</script>

<style scoped>
@media screen and (max-width: 991px) {
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .show {
    display: block !important;
  }
  .none {
    display: none !important;
  }
}
.show {
  display: none;
}
.dcbd:hover {
  transform: scale(1.2);
}

.qieh {
  width: calc(100px + 0.4vw);
  text-align: center;
  border-radius: 12px 12px 0 0;
}
</style>